@if (!isEditContactOpen) {
  <div class="contact-view">
    @if (!isInternal()) {
      <div class="flex justify-end mb-6 md:mb-4">
        <button type="button" class="contact-edit-btn inline-flex items-center gap-2 py-2.5 px-5 md:px-4 rounded-md text-[1.4rem] font-medium cursor-pointer transition-all duration-200 w-full md:w-auto justify-center" (click)="onOpenEditContact()">
          <i class="fa fa-pencil text-[1.3rem]"></i>
          {{ 'PERSONAL_DATA.PERSONAL_INFORMATION.PERSONAL_INFORMATION_CONTACTINFO.edit' | translate }}
        </button>
      </div>
    }

    <div class="flex flex-col gap-4">
      <!-- Fixed Phone -->
      <div class="contact-card flex flex-col gap-1 p-5 md:p-4 rounded-lg border">
        <span class="contact-card__label text-[1.2rem] md:text-[1.1rem] font-medium uppercase tracking-wide">{{ 'PERSONAL_DATA.PERSONAL_INFORMATION.fixedphone' | translate }}</span>
        @if (landlinePhone?.number?.trim()) {
          <span class="contact-card__value text-[1.5rem] md:text-[1.4rem] font-medium break-words">{{ landlinePhone?.number?.trim() }}</span>
        } @else {
          <span class="contact-card__value contact-card__value--empty text-[1.5rem] md:text-[1.4rem] font-medium italic">-</span>
        }
      </div>

      <!-- Mobile Phone -->
      <div class="contact-card flex flex-col gap-1 p-5 md:p-4 rounded-lg border">
        <span class="contact-card__label text-[1.2rem] md:text-[1.1rem] font-medium uppercase tracking-wide">{{ 'PERSONAL_DATA.PERSONAL_INFORMATION.mobilephone' | translate }}</span>
        @if (mobilePhone?.number?.trim()) {
          <span class="contact-card__value text-[1.5rem] md:text-[1.4rem] font-medium break-words">{{ mobilePhone?.number?.trim() }}</span>
        } @else {
          <span class="contact-card__value contact-card__value--empty text-[1.5rem] md:text-[1.4rem] font-medium italic">-</span>
        }
        <span class="contact-card__permission inline-flex items-center gap-1.5 mt-2 py-1.5 px-3 md:py-1 md:px-2.5 rounded text-[1.2rem] md:text-[1.1rem] w-fit">
          <i class="fa fa-shield-alt text-[1.1rem]"></i>
          {{ mobileContactPermission | mobileUse | translate }}
        </span>
      </div>

      <!-- Email -->
      <div class="contact-card flex flex-col gap-1 p-5 md:p-4 rounded-lg border">
        <span class="contact-card__label text-[1.2rem] md:text-[1.1rem] font-medium uppercase tracking-wide">{{ 'PERSONAL_DATA.PERSONAL_INFORMATION.email' | translate }}</span>
        @if (email?.emailAddress?.trim()) {
          <span class="contact-card__value text-[1.5rem] md:text-[1.4rem] font-medium break-words">{{ email?.emailAddress?.trim() }}</span>
        } @else {
          <span class="contact-card__value contact-card__value--empty text-[1.5rem] md:text-[1.4rem] font-medium italic">-</span>
        }
        <span class="contact-card__permission inline-flex items-center gap-1.5 mt-2 py-1.5 px-3 md:py-1 md:px-2.5 rounded text-[1.2rem] md:text-[1.1rem] w-fit">
          <i class="fa fa-shield-alt text-[1.1rem]"></i>
          {{ mailContactPermission | emailUse | translate }}
        </span>
      </div>
    </div>
  </div>
}

@if (isEditContactOpen) {
  <div class="contact-edit rounded-lg p-6 md:p-4">
    <!-- Header with close button -->
    <div class="contact-edit__toolbar flex items-center justify-between mb-6 md:mb-4 pb-4 md:pb-3 border-b">
      <h4 class="contact-edit__title flex items-center gap-3 m-0 text-[1.6rem] md:text-[1.4rem] font-semibold">
        <i class="fa fa-pencil"></i>
        {{ 'PERSONAL_DATA.PERSONAL_INFORMATION.PERSONAL_INFORMATION_CONTACTINFO.edit' | translate }}
      </h4>
      <button type="button" class="contact-close-btn inline-flex items-center justify-center w-9 h-9 p-0 rounded-full text-[1.4rem] cursor-pointer transition-all duration-200 shrink-0 border" (click)="onCloseEditContact()">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <myabvv-alert class="mb-4" [condition]="!!formGeneralError" [message]="formGeneralError" [type]="'error'"></myabvv-alert>

    <!-- Fixed Phone Card (disabled) -->
    <div class="contact-field-card contact-field-card--disabled rounded-lg mb-4 overflow-hidden border opacity-70">
      <div class="contact-field-card__header flex items-center gap-3 py-4 px-5 md:py-3 md:px-4 border-b">
        <div class="contact-field-card__icon flex items-center justify-center w-8 h-8 md:w-7 md:h-7 rounded-lg text-[1.4rem] md:text-[1.2rem] shrink-0">
          <i class="fa fa-phone"></i>
        </div>
        <label class="contact-field-card__label text-[1.5rem] md:text-[1.4rem] font-semibold m-0" for="fixed-phone">{{ 'PERSONAL_DATA.PERSONAL_INFORMATION.fixedphone' | translate }}</label>
      </div>
      <div class="contact-field-card__content p-5 md:p-4">
        <input id="fixed-phone" class="contact-form-input w-full py-3 px-4 text-[1.5rem] rounded-md transition-all duration-200 border" type="text" [value]="landlinePhone?.number?.trim() || '-'" disabled>
        <p class="contact-form-hint text-[1.2rem] mt-2">
          <i class="fa fa-lock"></i>
          {{ 'USER_FEEDBACK.not_editable' | translate }}
        </p>
      </div>
    </div>

    <!-- Mobile Phone Card -->
    <div class="contact-field-card rounded-lg mb-4 overflow-hidden border">
      <div class="contact-field-card__header flex items-center gap-3 py-4 px-5 md:py-3 md:px-4 border-b">
        <div class="contact-field-card__icon flex items-center justify-center w-8 h-8 md:w-7 md:h-7 rounded-lg text-[1.4rem] md:text-[1.2rem] text-white shrink-0">
          <i class="fa fa-mobile-alt"></i>
        </div>
        <label class="contact-field-card__label text-[1.5rem] md:text-[1.4rem] font-semibold m-0" for="mobile-phone">{{ 'PERSONAL_DATA.PERSONAL_INFORMATION.mobilephone' | translate }}</label>
      </div>
      <div class="contact-field-card__content p-5 md:p-4">
        <myabvv-alert class="mb-4" [condition]="mobileError" [message]="mobileErrorMessage" [type]="'error'"></myabvv-alert>
        <input id="mobile-phone" class="contact-form-input w-full py-3 px-4 text-[1.5rem] rounded-md transition-all duration-200 border" type="text" [(ngModel)]="updatedMobilePhone" placeholder="+3247…"
               (ngModelChange)="onMobileChanged($event)" (keydown)="onPhoneKeyDown($event)" [disabled]="mobilePermission()">

        <div class="permission-section mt-4 pt-4 border-t border-dashed">
          <p class="permission-section__title flex items-center gap-2 text-[1.3rem] font-medium m-0 mb-3">
            <i class="fa fa-shield-alt"></i>
            {{ 'PERSONAL_DATA.PERSONAL_INFORMATION.PERSONAL_INFORMATION_CONTACTINFO.permission' | translate }}
          </p>
          <div class="radio-group flex flex-col gap-3 mt-3 p-4 rounded-md">
            <div class="flex items-start gap-3">
              <input type="radio" name="opt-in-mobile" id="opt-in-1"
                     [value]="eContactPermission.ALL"
                     [(ngModel)]="mobileContactPermission"
                     (ngModelChange)="onMobilePermChanged($event)"
                     class="radio-native w-[18px] h-[18px] cursor-pointer">
              <label for="opt-in-1" class="text-[1.4rem] cursor-pointer">{{ 'PERSONAL_DATA.PERSONAL_INFORMATION.PERSONAL_INFORMATION_CONTACTINFO.phone_all' | translate }}</label>
            </div>
            <div class="flex items-start gap-3">
              <input type="radio" name="opt-in-mobile" id="opt-in-2"
                     [value]="eContactPermission.P"
                     [(ngModel)]="mobileContactPermission"
                     (ngModelChange)="onMobilePermChanged($event)"
                     class="radio-native w-[18px] h-[18px] cursor-pointer">
              <label for="opt-in-2" class="text-[1.4rem] cursor-pointer">{{ 'PERSONAL_DATA.PERSONAL_INFORMATION.PERSONAL_INFORMATION_CONTACTINFO.phone_personal' | translate }}</label>
            </div>
            <div class="flex items-start gap-3">
              <input type="radio" name="opt-in-mobile" id="opt-in-3"
                     [value]="eContactPermission.N"
                     [(ngModel)]="mobileContactPermission"
                     (ngModelChange)="onMobilePermChanged($event)"
                     class="radio-native w-[18px] h-[18px] cursor-pointer">
              <label for="opt-in-3" class="text-[1.4rem] cursor-pointer">{{ 'PERSONAL_DATA.PERSONAL_INFORMATION.PERSONAL_INFORMATION_CONTACTINFO.phone_none' | translate }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Email Card -->
    <div class="contact-field-card rounded-lg mb-4 overflow-hidden border">
      <div class="contact-field-card__header flex items-center gap-3 py-4 px-5 md:py-3 md:px-4 border-b">
        <div class="contact-field-card__icon flex items-center justify-center w-8 h-8 md:w-7 md:h-7 rounded-lg text-[1.4rem] md:text-[1.2rem] text-white shrink-0">
          <i class="fa fa-envelope"></i>
        </div>
        <label class="contact-field-card__label text-[1.5rem] md:text-[1.4rem] font-semibold m-0" for="email">E-mail</label>
      </div>
      <div class="contact-field-card__content p-5 md:p-4">
        <myabvv-alert class="mb-4" [condition]="emailError" [message]="emailErrorMessage" [type]="'error'"></myabvv-alert>
        <input id="email" class="contact-form-input w-full py-3 px-4 text-[1.5rem] rounded-md transition-all duration-200 border" type="text" [(ngModel)]="updatedEmail"
               [disabled]="emailPermission()" (ngModelChange)="onEmailChanged($event)">

        <div class="permission-section mt-4 pt-4 border-t border-dashed">
          <p class="permission-section__title flex items-center gap-2 text-[1.3rem] font-medium m-0 mb-3">
            <i class="fa fa-shield-alt"></i>
            {{ 'PERSONAL_DATA.PERSONAL_INFORMATION.PERSONAL_INFORMATION_CONTACTINFO.permission' | translate }}
          </p>
          <div class="radio-group flex flex-col gap-3 mt-3 p-4 rounded-md">
            <div class="flex items-start gap-3">
              <input type="radio" name="opt-in-email" id="email-opt-in-1"
                     [value]="eContactPermission.ALL"
                     [(ngModel)]="mailContactPermission"
                     (ngModelChange)="onMailPermChanged($event)"
                     class="radio-native w-[18px] h-[18px] cursor-pointer">
              <label for="email-opt-in-1" class="text-[1.4rem] cursor-pointer">{{ 'PERSONAL_DATA.PERSONAL_INFORMATION.PERSONAL_INFORMATION_CONTACTINFO.email_all' | translate }}</label>
            </div>
            <div class="flex items-start gap-3">
              <input type="radio" name="opt-in-email" id="email-opt-in-2"
                     [value]="eContactPermission.P"
                     [(ngModel)]="mailContactPermission"
                     (ngModelChange)="onMailPermChanged($event)"
                     class="radio-native w-[18px] h-[18px] cursor-pointer">
              <label for="email-opt-in-2" class="text-[1.4rem] cursor-pointer">{{ 'PERSONAL_DATA.PERSONAL_INFORMATION.PERSONAL_INFORMATION_CONTACTINFO.email_personal' | translate }}</label>
            </div>
            <div class="flex items-start gap-3">
              <input type="radio" name="opt-in-email" id="email-opt-in-3"
                     [value]="eContactPermission.M"
                     [(ngModel)]="mailContactPermission"
                     (ngModelChange)="onMailPermChanged($event)"
                     class="radio-native w-[18px] h-[18px] cursor-pointer">
              <label for="email-opt-in-3" class="text-[1.4rem] cursor-pointer">{{ 'PERSONAL_DATA.PERSONAL_INFORMATION.PERSONAL_INFORMATION_CONTACTINFO.email_my_inbox' | translate }}</label>
            </div>
            <div class="flex items-start gap-3">
              <input type="radio" name="opt-in-email" id="email-opt-in-4"
                     [value]="eContactPermission.N"
                     [(ngModel)]="mailContactPermission"
                     (ngModelChange)="onMailPermChanged($event)"
                     class="radio-native w-[18px] h-[18px] cursor-pointer">
              <label for="email-opt-in-4" class="text-[1.4rem] cursor-pointer">{{ 'PERSONAL_DATA.PERSONAL_INFORMATION.PERSONAL_INFORMATION_CONTACTINFO.email_none' | translate }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Privacy Notice -->
    <div class="contact-privacy-notice flex items-start gap-3 py-4 px-5 md:py-3 md:px-4 rounded-lg mb-6 border">
      <i class="fa fa-info-circle text-[1.4rem] mt-0.5 shrink-0"></i>
      <p class="m-0 text-[1.3rem] md:text-[1.2rem] leading-relaxed">
        {{ 'PERSONAL_DATA.PERSONAL_INFORMATION.privacy_statement' | translate }}
        @if (('LANGUAGE.lang' | translate) === 'nl') {
          <a href="https://fgtb.be/declaration-de-confidentialite" target="_blank" class="underline">ici</a>
        }
        @if (('LANGUAGE.lang' | translate) === 'fr') {
          <a href="https://abvv.be/privacyverklaring" target="_blank" class="underline">hier</a>
        }
      </p>
    </div>

    <!-- Form Actions -->
    <div class="contact-form-actions flex flex-col md:flex-row justify-end gap-4 mt-8 pt-6 border-t">
      <button type="button" class="c-button c-button--ghost" (click)="onReset()">
        <i class="fa fa-redo"></i>
        {{ 'BUTTON.reinitialise' | translate }}
      </button>
      @if (!isUpdating) {
        <button type="submit" class="contact-btn contact-btn--primary inline-flex items-center justify-center gap-2 py-3 px-6 text-[1.4rem] font-medium rounded-md cursor-pointer transition-all duration-200 w-full md:w-auto border" [disabled]="!canSubmit" (click)="onSubmitUpdateContact()">
          <i class="fa fa-check"></i>
          {{ 'USER_FEEDBACK.finished' | translate }}
        </button>
      }
      @if (isUpdating) {
        <button class="contact-btn contact-btn--primary inline-flex items-center justify-center gap-2 py-3 px-6 text-[1.4rem] font-medium rounded-md w-full md:w-auto" disabled>
          <i class="fa fa-spinner fa-pulse"></i>
        </button>
      }
    </div>
  </div>
}
